export default class AbstractGlass {
	constructor({
		ID,
		GLASS_DESCRIPTION,
		ID_VERAS,
		THICKNESS,
		CLEAR_GLASS,
		SOUND_INSULATION,
		M2_WEIGHT,
		RESISTANCE_CLASS,
		UV_PROTECTION,
		APPLICATION,
		MAX_WIDTH,
		MAX_HEIGHT,
		LAYERS,
	}) {
		this.dbIndex = -1;
		this.id = ID;
		this.glasstype = GLASS_DESCRIPTION;
		this.datasheets = null;

		this.id_veras = parseInt(ID_VERAS, 10);
		this.thickness = parseFloat(THICKNESS.replace(',', '.'));
		this.sound = parseFloat(SOUND_INSULATION);
		// CDR: if no sqmWeight is set, use the thickness * 2.5
		this.weight = parseFloat(M2_WEIGHT.replace(',', '.')) || this.thickness * 2.5;
		this.white_glass = CLEAR_GLASS || 'No';
		this.resistanceClass = RESISTANCE_CLASS;
		this.uv_protection = UV_PROTECTION;
		this.application = APPLICATION;
		const w = parseFloat(MAX_WIDTH);
		const h = parseFloat(MAX_HEIGHT);
		this.max_width = Math.max(w || 0, h || 0) || NaN; // always use the bigger (or non-NaN) value as width.. rules out issues later when checking max dimensions
		this.max_height = Math.min(w, h);
		this.layers = LAYERS
			? JSON.parse(LAYERS)
			: this.white_glass === 'Yes' || this.white_glass === 'Both'
				? [this.thickness + ':1']
				: [this.thickness + ':0'];
		this.errors = null;
	}

	checkErrors() {
		if (this.errors !== null) return this.errors;
		const errors = [];

		// Layer sum
		const sum = this.layers.reduce((acc, cur) => acc + parseFloat(cur.split(':')[0]), 0.0);
		if (sum !== this.thickness) {
			errors.push(
				`${this.id}: Glass ${this.glasstype}: Layerstärkensumme (${sum}) stimmt nicht mit Glasstärke überein (${this.thickness})`
			);
		}

		this.errors = errors;
		return errors;
	}

	get hasDatasheet() {
		return !!this.datasheets;
	}

	getDatasheet(preferredLanguage = null) {
		const ds = this.datasheets;
		if (!ds) return null;
		switch (preferredLanguage) {
			default:
			case 'de':
				if (ds.datasheet_de) return ds.datasheet_de;
				if (preferredLanguage) return this.getDatasheet();
			case 'fr':
				if (ds.datasheet_fr) return ds.datasheet_fr;
				if (preferredLanguage) return this.getDatasheet();
			case 'en':
				if (ds.datasheet_en) return ds.datasheet_en;
				if (preferredLanguage) return this.getDatasheet();
			case 'it':
				if (ds.datasheet_it) return ds.datasheet_it;
				if (preferredLanguage) return this.getDatasheet('fr');
		}
		return null;
	}
}
